module.exports = __webpack_public_path__ + "static/media/wildrice.b53d939a.jpg";